export const RESET_STORE = 'UTTO/RESET_STORE';
